import React from 'react';

export default function VolumenOffIcon() {
  return (
    <svg
      width="54px"
      height="54px"
      viewBox="0 0 54 54"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group volume X</title>
      <defs>
        <path
          d="M19.4791667,1.77415772 L19.4791667,26.5658244 C19.4791667,28.0506791 17.7615793,28.8761943 16.6021025,27.9486129 L8.23299187,21.2533244 L1.77083333,21.2533244 C0.792829089,21.2533244 8.8817842e-16,20.4604953 8.8817842e-16,19.4824911 L8.8817842e-16,8.85749105 C8.8817842e-16,7.87948681 0.792829089,7.08665772 1.77083333,7.08665772 L8.23299187,7.08665772 L16.6021025,0.391369204 C17.7615793,-0.536212201 19.4791667,0.289302977 19.4791667,1.77415772 Z M15.9375,5.45859755 L9.96039748,10.2402796 C9.64640562,10.4914731 9.25627244,10.6283244 8.85416667,10.6283244 L3.54166667,10.6283244 L3.54166667,17.7116577 L8.85416667,17.7116577 C9.25627244,17.7116577 9.64640562,17.8485091 9.96039748,18.0997025 L15.9375,22.8813846 L15.9375,5.45859755 Z M27.0811651,7.6053228 C27.7727185,6.91376936 28.8939482,6.91376936 29.5855016,7.6053228 L33.646,11.666 L37.7061651,7.6053228 C38.3570389,6.95444898 39.3885256,6.91616228 40.0841774,7.49046271 L40.2105016,7.6053228 C40.902055,8.29687623 40.902055,9.41810588 40.2105016,10.1096593 L36.15,14.17 L40.2105016,18.2303228 C40.8613754,18.8811966 40.8996621,19.9126833 40.3253617,20.6083351 L40.2105016,20.7346593 C39.5189482,21.4262127 38.3977185,21.4262127 37.7061651,20.7346593 L33.646,16.674 L29.5855016,20.7346593 C28.9346278,21.3855331 27.9031411,21.4238198 27.2074893,20.8495194 L27.0811651,20.7346593 C26.3896116,20.0431059 26.3896116,18.9218762 27.0811651,18.2303228 L31.142,14.17 L27.0811651,10.1096593 C26.4302913,9.45878549 26.3920046,8.42729883 26.966305,7.73164703 Z"
          id="path-1"
        ></path>
      </defs>
      <g
        id="Video-UI-Simple-Player-desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id='MacBook-Pro-16"-Publi-ID' transform="translate(-186, -260)">
          <g id="Group-volume-X" transform="translate(188, 262)">
            <circle
              id="Oval"
              stroke="#FFFFFF"
              strokeWidth="2"
              fill="#14B395"
              opacity="0.9"
              cx="25"
              cy="25"
              r="26"
            ></circle>
            <g id="volume-x" transform="translate(5.5208, 10.8333)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
              <g id="🎨Color" mask="url(#mask-2)" fill="#FFFFFF">
                <g transform="translate(-1.7708, -7.0833)" id="Rectangle">
                  <rect x="0" y="0" width="42.5" height="42.5"></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
